function MenuItem({ item, addToCart }) {
  return (
    <div className="menu-item">
      <img
        src={item.image}
        alt={item.name}
        loading="lazy"
        onError={(e) => {
          e.target.src = "https://via.placeholder.com/400";
        }}
      />
      <h3>{item.name}</h3>
      <p>{item.price}</p>
      <button onClick={() => addToCart(item)}>Add to Cart</button>
    </div>
  );
}

export default MenuItem;